import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(DrawSVGPlugin);

const LineDraw = () => {
  const pathRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      pathRef.current,
      { drawSVG: "0%" },
      {
        drawSVG: "100%",
        duration: 2.5,
        ease: "power2.out",
      }
    );
  }, []);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="663"
      height="622"
      viewBox="0 0 663 622"
      fill="none"
    >
      <path
        ref={pathRef}
        d="M43.6207 226.899C97.2513 175.102 105.649 161.999 159.972 122.305C171.947 113.555 184.763 106.091 203.215 97.3317C221.666 88.5722 245.591 79.0631 276.919 70.4758C308.248 61.8885 346.254 54.5112 375.864 49.9369C405.474 45.3627 425.536 43.815 443.415 43.6411C476.4 43.3204 494.501 46.8123 501.32 50.44C505.819 52.8335 511.417 58.0449 513.478 63.7398C515.539 69.4346 513.637 75.8887 509.682 82.2899C505.726 88.6911 499.775 94.844 486.822 105.945C473.869 117.046 454.093 132.908 405.495 163.449C356.897 193.99 280.076 238.728 233.674 268.841C171.1 309.448 160.212 329.702 162.269 333.041C164.312 336.356 174.449 335.488 201.131 334.216C221.328 333.254 254.893 329.306 308.785 317.839C362.676 306.372 435.839 286.908 481.273 275.901C526.707 264.895 542.195 262.936 554.796 262.759C576.691 262.453 589.403 268.836 595.293 274.354C598.029 276.917 599.926 279.334 600.815 283.113C601.705 286.892 601.446 292.047 599.663 296.686C596.076 306.016 575.865 320.97 545.629 341.989C531.137 352.064 516.647 358.337 486.216 368.55C455.784 378.763 409.409 392.059 380.553 401.02C341.429 413.169 319.779 426.228 300.058 439.788C287.455 448.454 282.78 455.647 279.639 462.701C274.38 474.509 274.567 485.49 276.682 492.413C280.543 505.049 296.021 513.532 333.206 523.693C363.08 531.856 416.683 540.55 454.186 546.757C491.689 552.963 511.823 554.994 533.879 558.492C555.934 561.99 579.303 566.892 593.359 570.253C607.416 573.613 611.451 575.282 618.792 577.669"
        stroke="#C8F22B"
        strokeWidth="87.2411"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default LineDraw;